export default
{
    //Period that a product shows the "NEW" tag on retail/stock stores (in Days) 
    showNewProductTagFor: 30, //Days
    //Period that a product shows the "BACK IN STOCK" tag on retail/stock stores (in Days) 
    showProductBackInStoreTagFor: 30 //Days
}